import { Component } from '@angular/core';

@Component({
  selector: 'peca-purchase-order-menu',
  templateUrl: './purchases-menu.component.html',
  styleUrls: ['./purchases-menu.component.scss'],
  standalone: false,
})
export class PurchaseOrdersComponent {}
